const dueStateTypes = {
  OVERDUE: {
    order: 1,
    color: "error",
    text: "Recruiting.Dashboard.OpenTasksOverdue"
  },
  UPCOMING: {
    order: 2,
    color: "warning",
    text: "Recruiting.Dashboard.OpenTasksUpcoming"
  },
  FUTURE: {
    order: 3,
    color: "success",
    text: "Recruiting.Dashboard.OpenTasksFuture"
  }
};

export default Object.freeze(dueStateTypes);
